

/* eslint-disable no-nested-ternary */
import React, { useState, useCallback, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import { useTranslation } from 'react-i18next'
import Layout from '../../layout/Layout/Layout'
import Modal from '../../components/Modal/Modal'
import Loading from 'custom/assets/loaders/Loading'
import DashboardService from '../../services/dashboard.service'
import { SIDENAV_KEYS, DIALOG_KEYS } from '../../utils/translation-constants'
import ServiceRequestCard from './ServiceRequestCard'
import moment from 'moment'
import OthersIcon from 'custom/assets/icons/expenses/others'
import { useHistory } from 'react-router-dom'

export default function ServiceRequest() {
  const { t } = useTranslation()
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const fetchServiceRequestList = useCallback(async () => {
    setLoading(true)
    try {
      const list = await DashboardService.serviceRequestView()
      setTransactions(list.data)
      setLoading(false)
    } catch (error) {
      setTransactions([])
      setLoading(false)
    }
  },[],
  )

  useEffect(() => {
    fetchServiceRequestList()
  }, [])


  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function newFunction(x, index) {
    return (
      <div key={index}>
        <h6 className='small font-weight-bold text-uppercase text-secondary'>
        </h6>
        <ServiceRequestCard
          icon={OthersIcon}
          title={x.category}
          time={moment(x.serviceReqDate).format('L')}
          transaction={x}
          status={x.status}
        />
      </div>
    )
  }

  return (
      <Layout>
        <div >
          <h4 className='font-weight-bold'>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.TITLE)}</h4>
          <p className='lead'>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.SUBTITLE)}</p>

          <div
            style={{ cursor: 'pointer', fontWeight: '600' }}
            onClick={() => history.push('/serviceRequest')}>
            Add Service Request
              </div>
        </div>

        <div style={{ overflowY: 'scroll', height: 600 }}>
          {loading ? (
            <p className='d-flex align-items-center justify-content-center'>
              <Loading />
            </p>
          ) : (
              transactions.map((x, i) => newFunction(x, i))
            )}
        </div>
      </Layout>
  )
}
